import styled from "@emotion/styled";
export var MarkerWrapper = /*#__PURE__*/ styled("div", {
    target: "e1an7a2i0"
})("position:relative;top:-6px;left:0;z-index:", function(p) {
    return p.isSelected ? "1" : "";
}, ";width:2.5rem;height:2.5rem;cursor:pointer;");
export var MarkerIconWrapper = /*#__PURE__*/ styled("div", {
    target: "e1an7a2i1"
})("position:absolute;top:0;left:0;fill:", function(param) {
    var isSelected = param.isSelected, theme = param.theme;
    return isSelected ? theme.color.primaryGradient1 : theme.color.primary;
}, ";filter:drop-shadow(0 1px 3px rgb(0 0 0 / 30%));& > svg{width:2.5rem;height:2.5rem;}");
export var StationTypeIcon = /*#__PURE__*/ styled("div", {
    target: "e1an7a2i2"
})("position:absolute;top:4px;left:9px;z-index:1;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";& > svg{width:1.375rem;height:1.375rem;}");
